'use client';

import styles from '../../page.module.scss';
import ArticleCard from './cards/ArtilcleCard';
import Footer from '../static-sections/Footer';
import { useEffect, useState } from 'react';
import { getArticles, setContentDynamicSections } from '../../lib/ConnectApi';

const AllArticles = () => {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fectchData = async () => {
      try {
        const fetchData = await getArticles();
        fetchData && setData(fetchData);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };
    fectchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const articles: any = setContentDynamicSections(data, 'article');

  return (
    <section className={`${styles.allArticlesMainContainer}  ${!show && styles.slowShow}`}>
      <header className={styles.allArticlesHeader}>
        <img
          className={styles.allArticlesImage}
          src={'/assets/images/nena.jpeg'}
          alt="imagen de niña leyendo"
        />
        <div className={styles.allArticlesHeaderContent}>
          <h1>todos nuestros artículos</h1>
          <p>Entrevistas, reseñas, recomendaciones, artículos y mucho más...</p>
        </div>
      </header>
      <main>
        {data.length > 0
          ? articles.reverse().map(
              (art: any, index: number) =>
                art.published && (
                  <div key={index}>
                    <ArticleCard
                      title={art.mainTitle}
                      author={art.author}
                      image={art.cardImage}
                      href={`/articulo/${art.slug}`}
                    />
                  </div>
                )
            )
          : [1, 2, 3, 4, 5, 6].map((art: any, index: number) => (
              <div key={index} className={styles.articleCardLoader}></div>
            ))}
      </main>
      <div className={styles.footerAllArticles}>
        <Footer />
      </div>
    </section>
  );
};

export default AllArticles;
